import { captureTypedPosthogEvent, type LayerLibraryResetFallbackTarget, POSTHOG_EVENTS } from '~/common/posthogEvents';

/**
 * Typed PostHog event wrappers for the Layer Library surface.
 *
 * Kept as a thin module (not inline in the page) so the event names + property shapes are
 * unit-testable without rendering the page, and so the org-id plumbing lives in one place.
 */

export function trackLayerLibraryOpened(organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.layerLibraryOpened, { organization_id: organizationId });
}

export function trackLayerLibraryClosed(organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.layerLibraryClosed, { organization_id: organizationId });
}

export function trackLayerLibraryLayerAdded(layerId: string, scope: string, organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.layerLibraryLayerAdded, {
    layer_id: layerId,
    scope,
    organization_id: organizationId,
  });
}

export function trackLayerLibraryLayerRemoved(layerId: string, scope: string, organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.layerLibraryLayerRemoved, {
    layer_id: layerId,
    scope,
    organization_id: organizationId,
  });
}

export function trackLayerLibraryReset(
  removedCount: number,
  organizationId: string | undefined,
  fallbackTarget: LayerLibraryResetFallbackTarget,
): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.layerLibraryReset, {
    removed_count: removedCount,
    organization_id: organizationId,
    fallback_target: fallbackTarget,
  });
}

export function trackLayerLibraryScopeChanged(from: string, to: string, organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.layerLibraryScopeChanged, {
    from,
    to,
    organization_id: organizationId,
  });
}

/** Fired on a committed, non-empty search. The raw query is intentionally omitted (PII). */
export function trackLayerLibrarySearched(organizationId?: string): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.layerLibrarySearched, { organization_id: organizationId });
}

/** Org-admin clicked the cross-link to the org Layer Library settings tab (CG-724). */
export function trackLayerLibraryOrgLinkClicked(): void {
  captureTypedPosthogEvent(POSTHOG_EVENTS.layerLibraryOrgLinkClicked, {});
}
